export default __webpack_public_path__ + "static/media/959BDE33-4ABA-4D9F-B64E-2CF974C31F46.2778fbd7.jpeg";